export default __webpack_public_path__ + "static/media/furniture.e24a86ed.png";